import { render, staticRenderFns } from "./BaseBadge.vue?vue&type=template&id=88a52b3c&scoped=true&"
import script from "./BaseBadge.vue?vue&type=script&lang=js&"
export * from "./BaseBadge.vue?vue&type=script&lang=js&"
import style0 from "./BaseBadge.vue?vue&type=style&index=0&id=88a52b3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a52b3c",
  null
  
)

export default component.exports